import { createApp } from 'vue'
// import { createI18n } from 'vue-i18n'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import { plugin } from './authentication'
import i18n from './i18n/index'
import prototype from './prototype'

prototype()

const app = createApp(App).use(router).use(plugin).use(i18n)
app.mount('#app')
